import React from 'react';
import StatusIcon from '../StatusIcon';
import { Head, Caption, Action } from './wrappers';
import { Column, Columns } from '../Columns/wrappers';
import LinkButton from '../LinkButton';
import { StoreIcon } from '../Icon';
import { StockStatus as Status } from '../../../@types/stock.enum';
import Loader from '../Loader';
import { useTrackGenericEvent } from '../../hooks/tracking/useTrackingEvents';
import useCompose from '../../hooks/useCompose';

const otherStoresEvent = { event: 'other_stores_stock_status_click' };

interface IStockStatus {
  heading: string;
  loading?: boolean;
  onClick: () => void;
  status: Status;
  store?: string;
  text?: string;
  quantity?: number;
}

const StockStatus = ({
  heading,
  loading,
  onClick,
  status,
  store,
  text,
  quantity = 0,
}: IStockStatus) => {
  const trackOtherStoresStockStatus = useTrackGenericEvent(otherStoresEvent);
  const clickHandler = useCompose(trackOtherStoresStockStatus, onClick);

  return (
    <Columns className="space-2">
      <Column>
        <StoreIcon className="large bump-down" />
      </Column>
      <Column>
        <Head>
          <Columns className="space-half valign-middle">
            <Column>
              {loading && 'Hämtar lagerstatus'}
              {!loading && (
                <>
                  {heading}
                  <LinkButton weight="medium" onClick={onClick} title="Byt butik">
                    {store}
                  </LinkButton>
                </>
              )}
            </Column>
            <Column>
              {!loading && <StatusIcon status={status} quantity={quantity} />}
              {loading && <Loader className="bump-left" inline />}
            </Column>
          </Columns>
        </Head>
        {text && <Caption>{text}</Caption>}
        <Action onClick={clickHandler}>Se lagerstatus i andra butiker</Action>
      </Column>
    </Columns>
  );
};

export default StockStatus;
